;(function() {
  'use strict'

  angular.module('app.core').factory('WeightRule', Factory)

  /* @ngInject */
  function Factory() {
    function WeightRule() {
      this.applyDefaults()
    }

    WeightRule.prototype.applyDefaults = function() {
      _.defaultsDeep(this, {
        filterId: null,
        weight: null,
      })
    }

    WeightRule.prototype.deserialize = function(data) {
      data = _.isPlainObject(data) ? data : {}

      this.filterId = data.filterId
      this.weight = data.weight

      this.applyDefaults()
      return this
    }

    WeightRule.prototype.serialize = function() {
      var data = {}
      data.filterId = this.filterId
      data.weight = this.weight
      return data
    }

    WeightRule.prototype.validate = function(filters) {
      var errors = []

      if (!this.filterId) {
        errors.push('Filter is required for weight rule')
      } else if (!_.find(filters, { id: this.filterId })) {
        errors.push('Selected filter can not be found. ')
      }

      if (!_.isNumber(this.weight) || this.weight < 0) {
        errors.push(
          'Weight must be a positive number or zero. Decimal is allowed'
        )
      }

      this.errors = errors.length ? errors : null
      return !errors.length
    }

    WeightRule.prototype.match = function(row, filtersById) {
      var filter = filtersById[this.filterId]
      if (!filter) {
        return 0
      }
      return filter.match(row)
    }

    return WeightRule
  }
})()
